customElements.define('cookie-popup', class extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (sessionStorage.getItem('cookiePolicyAccepted')) return;
        this.style.display = 'block';
        setTimeout(() => {
            this.classList.add('active');
        }, 3000);
        this.addEventListeners();
    }
    
    addEventListeners() {
        const acceptButton = this.querySelector('.accept-button');
        if (acceptButton) {
            acceptButton.addEventListener('click', () => {
                sessionStorage.setItem('cookiePolicyAccepted', 'true');
                this.classList.remove('active');
            });
        }
    }
});